import React, { useEffect, useState } from "react";
import MicroModal from "micromodal";
import './style.css';
import ReactHtmlParser from 'react-html-parser'

MicroModal.init();

const QuickAnswer = ({message,variables,sendTextInputChat,actionSendMessageClient,actionCancelMessageClient,changeVariablesSending,bind,screen}) => {
    const [text, handleText] = useState("");
    const [variablesReceived, handleVariablesReceived] = useState([]); 

    const handleValueVariable = (textDigited,nameVariableReceived) => {
        let variableQuickAnwser = variablesReceived;
        for(let variable of variableQuickAnwser){
          if(variable.name === nameVariableReceived){
            variable.value = textDigited;
          }
        }
        handleVariablesReceived(variableQuickAnwser)
        changeVariablesSending(variableQuickAnwser)
        createPreviewMessage(true);
    }

    useEffect(() => {
        handleVariablesReceived(variables)
        changeVariablesSending(variables)
    }, [variables])

    const createPreviewMessage = (isSendText) => {
        let tempText = message;
        let textToSend = message;
        tempText = tempText.replace(/<+/g, "*")
        tempText = tempText.replace(/>+/g, "*")
        tempText = tempText.replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        for(let variable of variables){
            tempText = tempText.replace('${'+variable.name+'}', '<span className="marcatexto">'+variable.value+'</span>');
            textToSend = textToSend.replace('${'+variable.name+'}', variable.value);
        }
        handleText(tempText)
        if(isSendText)
            sendTextInputChat(textToSend,bind)
    }

    const checkVariablesMessage = () => {
        let checkVariables = false;
        variablesReceived.map((variable, index) => {
            if(variable.value === ""){
                if(document.getElementById(`variable-id-${index}`)){
                    document.getElementById(`variable-id-${index}`).className = "content--variables__option-input error";
                    checkVariables = true;
                }
            }
        })
        if(!checkVariables){
            actionSendMessageClient(bind);
        }
    }

    useEffect(() => {
        createPreviewMessage(false);
    }, [message])

  return (
        <div className="modal micromodal-slide" id={`modal__mensagens-predefinidas-${screen}`} aria-hidden="true" role="dialog">
            <div className="modal__overlay" tabIndex="-1">
                <div className="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal__agenda-pj-empresa-detalhes-editar-salvo__title">
                    <header className="modal__header">
                        <h2 className="modal__title" id="modal__agenda-pj-empresa-detalhes-editar-salvo__title">
                            Mensagens Predefinidas
                        </h2>
                        <button className="modal__close" aria-label="Close modal" onClick={event => actionCancelMessageClient(event,bind)}></button>
                    </header>
                    <main className="modal__content" id="modal__agenda-pj-empresa-detalhes-editar-salvo__content">
                        <form action="" className="modal__content__form-mensagens">
                            <div className="modal__content__form__row-mensagens">
                                <div className="modal__content__form__group modal__content__form__group--col-8">
                                    <label className="modal__content__form__group__label" htmlFor="modal__content__form__group__label">Preview da Mensagem:</label>
                                    <div className="modal__content__form__group__input-line">
                                        {/* <textarea className="text__preview-message" defaultValue={ReactHtmlParser(text)} disabled /> */}
                                        <div className="text__preview-message">
                                            {ReactHtmlParser(text)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal__content__form__row-mensagens">
                                <div className="modal__content__form__group modal__content__form__group--col-12">
                                    <div className='container__change-variables'>
                                        <label className="modal__content__form__group__label" htmlFor="modal__content__form__group__label">Alterar Variavéis:</label>
                                        {/* <hr className='line__fieldset'></hr> */}
                                    </div>
                                </div>
                            </div>
                            <div className="modal__content__form__row-variables">
                            {
                            variablesReceived.map((todo, index) => (
                                    <div className="content-variables">
                                        <label className="content-variables__option-label">{'${'}{todo.name}{'}'}</label>
                                        <input type="text" id={`variable-id-${index}`} name="variable" onChange={event => handleValueVariable(event.target.value,todo.name,variables)} className="content--variables__option-input" disabled={todo.name === "SYS.NOMEAGENTE" ? true:false } defaultValue={todo.value} value={todo.value} />
                                    </div>
                                ))
                            }
                            </div>
                        </form>
                        <form action="" className="modal__content__form">
                            <div className="modal__content__form__group modal__content__form__group--col-5">
                            
                            </div>
                            <div className="modal__content__form__group modal__content__form__group--col-2">
                                <a className="modal__content__form__group__button" onClick={event => checkVariablesMessage()}>{screen === 'mail' ? 'Aplicar':'Enviar Mensagem'}</a>
                            </div>
                            <div className="modal__content__form__group modal__content__form__group--col-1">
                                <a className="modal__content__form__group__button modal__content__form__group__button--white" onClick={event => actionCancelMessageClient(event,bind)}>Cancelar</a>
                            </div>
                        </form>
                    </main>
                </div>
            </div>
        </div>
  );
};

export default QuickAnswer;




